import { useMemo, useRef } from "react";
import requireAuth from "../context/requireAuth";
import { useNavigate } from "react-router-dom";
import SignatureCanvas from 'react-signature-canvas'
import { Button, Grid } from "@mui/material";
import axios from "../context/axiosConfig";

function DestroySignature() {

    const navigate = useNavigate();

    const org_id = localStorage.getItem("organization");

    const signature1Ref = useRef();
    const signature2Ref = useRef();

    console.log({ signature1Ref, signature2Ref })
    /**
     * @type {{type: string, page: string, objects: string[]}}
     */
    const deleteObject = useMemo(() => {
        const deleteSession = window.sessionStorage.getItem("toDelete");

        console.log({ delete: "test", deleteSession })

        if (!deleteSession) {
            console.log("navigating to main")
            navigate("/main");
            return {}
        } else {
            try {
                return JSON.parse(deleteSession)
            } catch (error) {
                console.error(error)
                navigate("/main")
                return {}
            }
        }
    }, [navigate])

    const handleDestroyObjects = async (event) => {
        event.preventDefault()
        if (signature1Ref.current.isEmpty() || signature2Ref.current.isEmpty()) {
            alert("Please sign both fields!");
            return;
        }

        const signature1DataURL = signature1Ref.current.toDataURL();
        const signature2DataURL = signature2Ref.current.toDataURL();

        switch (deleteObject.type) {
            case "plant":
                await handlePlantDestroy(signature1DataURL, signature2DataURL);
                break;
            case "plot":
                await handlePlotDestroy(signature1DataURL, signature2DataURL);
                break;
            default:
                console.error(`deleteObjectType ${deleteObject.type} is not a valid type!`)
                alert("Something went wrong!")
        }
        window.sessionStorage.removeItem("toDelete")
        navigate(deleteObject.page);
    }

    const handlePlantDestroy = (signature1DataURL, signature2DataURL) => {
        return new Promise((resolve, reject) => {


            const body = {};
            console.log({ deleteObject })
            body["ids"] = deleteObject.objects;
            body["signature1"] = signature1DataURL;
            body["signature2"] = signature2DataURL;
            // body["ids"] = deleteObject.objects.plant_id;


            axios
                .post(`orgs/${org_id}/plants/deleteplants`, body, { withCredentials: true })
                .then((res) => {
                    alert(`Plants were succesfully destroyed`);
                    resolve()
                })
                .catch((error) => {
                    console.error(error);
                    alert("Something went wrong! Try Again");
                    reject()
                });
        })
    }

    const handlePlotDestroy = (signature1DataURL, signature2DataURL) => {
        return new Promise((resolve, reject) => {
            const body = {};
            console.log({ deleteObject })
            body["ids"] = deleteObject.objects;
            body["signature1"] = signature1DataURL;
            body["signature2"] = signature2DataURL;

            axios
                .post(`orgs/${org_id}/plots/deleteplots`, body, { withCredentials: true })
                .then((res) => {
                    alert("Plot was succesfully destroyed");
                    resolve()
                })
                .catch((error) => {
                    console.error(error);
                    alert(`Something went wrong! ${error.request.response}`);
                    reject()
                });
        })
    }

    if (!deleteObject.objects) {
        return (
            <div className="bodyContent">
                <h1>Something went wrong!</h1>
                <h3>
                    Please try again later. If this error persists, please contact
                </h3>
                <a target="_blank" rel="noreferrer" href="mailto:support@yookr.org">
                    yookr: support@yookr.org
                </a>
            </div>
        )
    }

    console.log(deleteObject)


    return (
        <div className="bodyContent">
            <h2 className="subheader">Destroy {deleteObject.type}</h2>
            <h4>
                Are you sure that you want to delete the following {deleteObject.type}{deleteObject.objects.length === 1 ? "" : "s"}: {deleteObject.ids.join(",")}
            </h4>
            <Grid container gap={2} justifyContent="space-evenly">
                <Grid item>
                    <h3>Signature 1 - <Button variant="contained" color="error" onClick={() => signature1Ref.current.clear()}>Clear</Button></h3>
                    <SignatureCanvas canvasProps={{ width: 500, height: 300, className: 'signatureCanvas' }} ref={signature1Ref} />
                </Grid>
                <Grid>
                    <h3>Signature 2 - <Button variant="contained" color="error" onClick={() => signature2Ref.current.clear()}>Clear</Button></h3>
                    <SignatureCanvas canvasProps={{ width: 500, height: 300, className: 'signatureCanvas' }} ref={signature2Ref} />

                </Grid>
            </Grid>

            <Grid container justifyContent="center" sx={{ margin: "1em 0" }}>
                <form className="editForm" onSubmit={handleDestroyObjects}>
                    <Button sx={{ fontSize: "30px" }} type="submit" variant="contained" color="error">Destroy</Button>
                </form>
            </Grid>
        </div>
    )
}


export default requireAuth(DestroySignature);